// The browser id of the presence signal (utils/presenceBeacon.js), read-only.
// Deliberately free of imports: includes/auth sends it with sign in / sign
// out without importing the beacon (which itself imports includes/auth).
export const VISITOR_STORAGE_KEY = "elakay_visitor_id";

// Never creates an id; empty when absent, malformed or storage is blocked.
export const readPresenceVisitorId = () => {
  try {
    const id = window.localStorage.getItem(VISITOR_STORAGE_KEY) || "";
    return /^[A-Za-z0-9_-]{8,64}$/.test(id) ? id : "";
  } catch {
    return "";
  }
};
